//TOPICS
const topicsSlides = document.getElementById('topicsSlide');
const splide = new Splide(topicsSlides, {
	type: "slide",
	speed: 1000,
	perPage: 2,
	perMove: 1,
	arrows: true,
	pagination: false,
	destroy: true, // スライダーを破棄
	//gap: "20px",
	arrowPath: "M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z",
	classes: {
		prev: 'slider-button slider-button--prev',
		next: 'slider-button slider-button--next',
	},
	breakpoints: {
		990: {
			destroy: false, // 767px未満でスライダー開始
		},
		750: {
			perPage: 1,
		},
	},
}).mount();
